import { render, staticRenderFns } from "./CopyCode.vue?vue&type=template&id=52281ce0&scoped=true&lang=pug"
import script from "./CopyCode.vue?vue&type=script&lang=js"
export * from "./CopyCode.vue?vue&type=script&lang=js"
import style0 from "./CopyCode.vue?vue&type=style&index=0&id=52281ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52281ce0",
  null
  
)

export default component.exports